/**
 * DTFNY first-touch lead source tracking
 * Write-once cookie dtfny_ft (+ dtfny_ft_detail). Never overwrite.
 * Stamps Shopify cart attributes first_touch / first_touch_detail once.
 */
(function () {
  'use strict';

  var COOKIE = 'dtfny_ft';
  var COOKIE_DETAIL = 'dtfny_ft_detail';
  var LS_KEY = 'dtfny_ft';
  var LS_DETAIL = 'dtfny_ft_detail';
  var MAX_AGE = 31536000; // ~1 year
  var ATTR_FT = 'first_touch';
  var ATTR_DETAIL = 'first_touch_detail';

  function getCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|;\\s*)' + name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }

  function setCookie(name, value) {
    var secure = location.protocol === 'https:' ? '; Secure' : '';
    document.cookie =
      name +
      '=' +
      encodeURIComponent(value) +
      '; Path=/; Max-Age=' +
      MAX_AGE +
      '; SameSite=Lax' +
      secure;
  }

  function lsGet(key) {
    try {
      return localStorage.getItem(key) || '';
    } catch (e) {
      return '';
    }
  }

  function lsSet(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch (e) {}
  }

  function readExisting() {
    return getCookie(COOKIE) || lsGet(LS_KEY) || '';
  }

  function readExistingDetail() {
    return getCookie(COOKIE_DETAIL) || lsGet(LS_DETAIL) || '';
  }

  function persist(source, detail) {
    if (!source) return;
    setCookie(COOKIE, source);
    lsSet(LS_KEY, source);
    if (detail) {
      setCookie(COOKIE_DETAIL, detail);
      lsSet(LS_DETAIL, detail);
    }
  }

  function params() {
    try {
      return new URLSearchParams(window.location.search || '');
    } catch (e) {
      return new URLSearchParams();
    }
  }

  function norm(s) {
    return (s || '').toString().trim().toLowerCase();
  }

  function truncate(s, n) {
    s = (s || '').toString();
    return s.length > n ? s.slice(0, n) : s;
  }

  /**
   * Classify current hit. Returns { source, detail } or null if no clear signal
   * and we should leave unset / direct only when no first touch yet.
   */
  function classify(p, referrer, hasFirstTouch) {
    var utmSource = norm(p.get('utm_source'));
    var utmMedium = norm(p.get('utm_medium'));
    var utmCampaign = norm(p.get('utm_campaign'));
    var gclid = (p.get('gclid') || '').toString().trim();

    var emailSources = { email: 1, klaviyo: 1, newsletter: 1, mailchimp: 1, broadcast: 1 };
    var salesSources = { sales: 1, 'sales-call': 1, rep: 1 };
    var googleSources = { google: 1, googleads: 1, adwords: 1, youtube: 1 };
    var googleMediums = { cpc: 1, ppc: 1, organic: 1, gbp: 1 };

    // Email first (explicit email beats ambiguous google-ish noise)
    if (emailSources[utmSource] || utmMedium === 'email') {
      return { source: 'email', detail: buildDetail(utmSource, utmMedium, utmCampaign, gclid) };
    }

    // Sales
    if (salesSources[utmSource] || utmMedium === 'call' || utmCampaign.indexOf('rep-') === 0) {
      return { source: 'sales', detail: buildDetail(utmSource, utmMedium, utmCampaign, gclid) };
    }

    // Google: exact sources, mediums, gclid, substring google in utm_source
    if (
      googleSources[utmSource] ||
      googleMediums[utmMedium] ||
      gclid ||
      utmSource.indexOf('google') !== -1
    ) {
      return { source: 'google', detail: buildDetail(utmSource, utmMedium, utmCampaign, gclid) };
    }

    // Referrer google only when no first touch yet (and no clearer param above)
    if (!hasFirstTouch && referrer) {
      try {
        var host = new URL(referrer).hostname.toLowerCase();
        if (
          host === 'google.com' ||
          host.indexOf('.google.com') !== -1 ||
          host.indexOf('googleadservices') !== -1 ||
          host.indexOf('googleusercontent') !== -1
        ) {
          return { source: 'google', detail: buildDetail(utmSource, utmMedium, utmCampaign, '') + '|ref=' + truncate(host, 80) };
        }
      } catch (e) {}
    }

    // No clear paid/email/sales signal — only set direct if nothing stored yet
    if (!hasFirstTouch) {
      // Prefer leaving unset unless we want direct for attribution baseline.
      // Spec: leave unset (or `direct`) — do NOT invent google/email.
      return { source: 'direct', detail: buildDetail(utmSource, utmMedium, utmCampaign, gclid) || 'direct' };
    }

    return null;
  }

  function buildDetail(utmSource, utmMedium, utmCampaign, gclid) {
    var parts = [utmSource || '', utmMedium || '', utmCampaign || '', gclid || ''];
    var raw = parts.join('|');
    if (raw === '|||') return '';
    return truncate(raw, 180);
  }

  function stampFirstTouch() {
    var existing = readExisting();
    if (existing) {
      // Never overwrite — optionally backfill cookie from LS or vice versa
      if (!getCookie(COOKIE) && existing) setCookie(COOKIE, existing);
      if (!lsGet(LS_KEY) && existing) lsSet(LS_KEY, existing);
      var det = readExistingDetail();
      if (det) {
        if (!getCookie(COOKIE_DETAIL)) setCookie(COOKIE_DETAIL, det);
        if (!lsGet(LS_DETAIL)) lsSet(LS_DETAIL, det);
      }
      return existing;
    }

    var hit = classify(params(), document.referrer || '', false);
    if (!hit || !hit.source) return '';
    persist(hit.source, hit.detail || '');
    return hit.source;
  }

  function cartRoutes() {
    var r = (window.routes && window.routes.cart_url) || '/cart';
    return {
      cart: r,
      update: (window.routes && window.routes.cart_update_url) || '/cart/update.js',
      add: (window.routes && window.routes.cart_add_url) || '/cart/add.js',
      change: (window.routes && window.routes.cart_change_url) || '/cart/change.js',
    };
  }

  function getCartAttributes() {
    return fetch((cartRoutes().cart || '/cart') + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .catch(function () {
        return null;
      });
  }

  function setCartAttrsIfEmpty(source, detail) {
    if (!source) return Promise.resolve();
    return getCartAttributes().then(function (cart) {
      if (!cart) return;
      var attrs = cart.attributes || {};
      var curFt = (attrs[ATTR_FT] || '').toString().trim();
      var curDet = (attrs[ATTR_DETAIL] || '').toString().trim();
      var payload = {};
      var need = false;
      if (!curFt) {
        payload[ATTR_FT] = source;
        need = true;
      }
      if (!curDet && detail) {
        payload[ATTR_DETAIL] = detail;
        need = true;
      }
      if (!need) return;
      // Merge: only send the keys we are filling; Shopify update merges attributes
      return fetch(cartRoutes().update, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ attributes: payload }),
      }).catch(function () {});
    });
  }

  function syncCart() {
    var source = readExisting();
    var detail = readExistingDetail();
    if (!source) return Promise.resolve();
    return setCartAttrsIfEmpty(source, detail);
  }

  // Hook fetch for cart/add.js, cart/update.js, cart/change.js
  function hookFetch() {
    if (!window.fetch || window.__dtfnyFtFetchHooked) return;
    window.__dtfnyFtFetchHooked = true;
    var orig = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var url = '';
      try {
        if (typeof args[0] === 'string') url = args[0];
        else if (args[0] && args[0].url) url = args[0].url;
      } catch (e) {}
      var p = orig.apply(this, args);
      try {
        var u = (url || '').toLowerCase();
        if (u.indexOf('/cart/add') !== -1 || u.indexOf('/cart/update') !== -1 || u.indexOf('/cart/change') !== -1) {
          p.then(function () {
            syncCart();
          }).catch(function () {});
        }
      } catch (e) {}
      return p;
    };
  }

  // Hook XHR similarly (some themes still use it)
  function hookXHR() {
    if (!window.XMLHttpRequest || window.__dtfnyFtXhrHooked) return;
    window.__dtfnyFtXhrHooked = true;
    var open = XMLHttpRequest.prototype.open;
    var send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__dtfnyFtUrl = url || '';
      return open.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      var self = this;
      var u = (self.__dtfnyFtUrl || '').toLowerCase();
      if (u.indexOf('/cart/add') !== -1 || u.indexOf('/cart/update') !== -1 || u.indexOf('/cart/change') !== -1) {
        self.addEventListener('load', function () {
          syncCart();
        });
      }
      return send.apply(this, arguments);
    };
  }

  // Before checkout navigation
  function hookCheckoutLinks() {
    document.addEventListener(
      'click',
      function (e) {
        var a = e.target && e.target.closest ? e.target.closest('a[href*="/checkout"], button[name="checkout"], [name="checkout"]') : null;
        if (!a) return;
        // Fire-and-forget sync; do not block navigation hard
        syncCart();
      },
      true
    );
    document.addEventListener(
      'submit',
      function (e) {
        var form = e.target;
        if (!form || !form.action) return;
        var act = (form.action || '').toLowerCase();
        if (act.indexOf('/cart') !== -1 || act.indexOf('checkout') !== -1 || (form.querySelector && form.querySelector('[name="checkout"]'))) {
          syncCart();
        }
      },
      true
    );
  }

  // Expose for debugging / tests
  window.DTFNYFirstTouch = {
    classify: function (search, referrer, hasFirstTouch) {
      var p;
      try {
        p = new URLSearchParams(search || '');
      } catch (e) {
        p = new URLSearchParams();
      }
      return classify(p, referrer || '', !!hasFirstTouch);
    },
    read: readExisting,
    readDetail: readExistingDetail,
    syncCart: syncCart,
  };

  // Boot
  stampFirstTouch();
  hookFetch();
  hookXHR();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      hookCheckoutLinks();
      syncCart();
    });
  } else {
    hookCheckoutLinks();
    syncCart();
  }
})();
